import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios';
import DocumentMeta from 'react-document-meta';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faSearch, faPlus, faFilter, faChevronLeft, faChevronDown, faWrench, faSmoking, faRoad, faBed, faBuilding, faHome, faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons'

import AppContext from '../../../AppContext.js';
import OffsetTop from '../../../components/offsetTop.js';

const localization = {
    ua: {
        title: 'Стемпінг',
        filter: {
            date: 'Дата'
        },
        searchText: 'Пошук...',
        noData: 'Данi вiдсутнi',
    },
    ru: {
        title: 'Стемпинг',
        filter: {
            date: 'Дата'
        },
        searchText: 'Поиск...',
        noData: 'Данi вiдсутнi',
    },
    en: {
        title: 'Stamping',
        filter: {
            date: 'Дата'
        },
        searchText: 'Filter...',
        noData: 'Данi вiдсутнi',
    },
}

class MechanicStamping extends React.Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);
		
		this.state = {
            isLoading: true,

            filterDate: null,
            mechanics: [],

            isOpen: false,

            mechanic: null,
            rows: []
        }

        this.dateToInputFormat= this.dateToInputFormat.bind(this);
        this.dateToDatabaseFormat= this.dateToDatabaseFormat.bind(this);

        this.changeDate= this.changeDate.bind(this);
        this.datePrev = this.datePrev.bind(this);
        this.dateNext = this.dateNext.bind(this);
        
        this.delete = this.deleteItem.bind(this);
    }

    componentDidMount() {
        const {lang, setMenuExpandText} = this.context;
        setMenuExpandText(localization[lang].title);

        this.setState({filterDate: Date.now()}, () => {
            this.loadList();
        });
    }

    dateToInputFormat(date) {
        var d = new Date(date);
        var month = '' + (d.getMonth() + 1);
        var day = '' + d.getDate();
        var year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
            
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    }

    dateToDatabaseFormat(date) {
        var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [day, month, year].join('.');
    }

    changeDate(event) {
        this.setState({filterDate: new Date(event.target.value).getTime()}, () => {
            this.loadList();
        });
    }

    datePrev() {
        this.setState({filterDate: this.state.filterDate - 86400000}, () => {
            this.loadList();
        });
    }

    dateNext() {
        this.setState({filterDate: this.state.filterDate + 86400000}, () => {
            this.loadList();
        });
    }

    deleteItem(kid, kitem) {
        const {addNotification, removeNotification, token} = this.context;
        
        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/service/mechanic/stamping/delete', { 
                token: token, 
                kid: kid, 
                kitem: kitem, 
            }).then((res) => {
                this.setState({result: res.data.result, serror: res.data.serror});
                this.setState({redirect: "/mechanic/stamping"});
                this.loadList();
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        }
    }

    autocompleteItem(kid) {
        const {addNotification, removeNotification, token} = this.context;
        
        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/service/mechanic/stamping/autocomplete', { 
                token: token, 
                kid: kid, 
            }).then((res) => {
                this.setState({result: res.data.result, serror: res.data.serror});
                this.setState({redirect: "/mechanic/stamping"});
                this.loadList();
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        }
    }

    loadList() {
        const {addNotification, removeNotification, token} = this.context;
        
        if (process.env.NODE_ENV === 'production') {
            var u = addNotification("Завантаження...");
            axios.post('/api/service/mechanic/stamping/list', { 
                token: token, 
                date: this.dateToDatabaseFormat(this.state.filterDate)
            }).then((res) => {
                this.setState({
                    rows: res.data.rows, 
                    isLoading: false
                });
            }).catch((error) => {
                addNotification(error.response.data, error.response.status);
            }).finally(function () {
                removeNotification(u);
            });
        } else {
            this.setState({
                isLoading: false,
                rows: [{
                    name: "Прогоріли шайби форсунок (ЗН 2300351)",
                    starttime: "10:51:49",
                    finishtime: "16:39:08",
                    hours: "5.78",
                    kid: 257,
                    kitem: 2,
                    date: "17.02.2023",
                    type: 0,
                    znumber: "2300351",
                    zname: "Прогоріли шайби форсунок"
                },
                {
                    name: "Простой",
                    starttime: "16:39:08",
                    finishtime: "16:40:18",
                    hours: "0.02",
                    kid: 257,
                    kitem: 4,
                    date: "17.02.2023",
                    type: 1,
                    znumber: "",
                    zname: "Простой"
                },
                {
                    name: "Вибите лобове скло (ЗН 2300149)",
                    starttime: "16:40:18",
                    finishtime: "16:40:30",
                    hours: "0.01",
                    kid: 257,
                    kitem: 3,
                    date: "17.02.2023",
                    type: 0,
                    znumber: "2300149",
                    zname: "Вибите лобове скло"
                }
                ]
            });
        }
    }
    
    groupColor(type) {
        switch(type) {
            case 0:
                return "#0091ea";
            case 1:  
                return "#ffab00";
            case 2:
                return "#b0bec5";
            case 3:  
                return "#c5cae9";
            case 4:
                return "#992450";
            default:
                return "";
          }
    }

    groupIcon(type) {
        switch(type) {
            case 1:
                return faWrench;
            case 2:  
                return faSmoking;
            case 3:
                return faRoad;
            case 4:  
                return faBed;
            case 5:
                return faBuilding;
            default:
                return faHome;
          }
    }

    normalizeStamp(stamp) {
        if (stamp == "") {
            return ". . .";
        }
        var datetime = stamp.split(" ");
        var time = datetime[1].split(":");
        var res = time[0] + ":" + time[1];

        if (res.length < 5) {
            res = "0"+res;
        }

        return res;
    }

    renderList() {const {lang} = this.context;

    if (this.state.rows.length === 0) {
        return (
            <div className="row">
                <div className="col">
                    <h6><b>{localization[lang].noData}</b></h6>
                </div>
            </div>
        );
    } else {
        return this.state.rows.map((item, i) => {
            var borderColor = this.groupColor(item.type);

            return (
                <div className="row pt-1 pb-1" key={"stamp_"+item.qid}>
                    <div className="col">
                        <div className="body pl-2 pt-1" style={{borderLeft: "4px solid" + borderColor}}>
                            <h6><b dangerouslySetInnerHTML={{__html: item.name}}></b></h6>
                        </div>
                        <div className="body pl-2 pt-1" style={{borderLeft: "4px solid" + borderColor}}>
                            <h6><span>{item.starttime + " - " + item.finishtime}</span></h6>
                        </div>
                        <div className="body pl-2 d-flex pt-1" style={{borderLeft: "4px solid" + borderColor}}>
                            <h6 className="mr-auto"><span dangerouslySetInnerHTML={{__html: "Час: " + item.hours}}></span></h6>
                            <Link to={"/mechanic/stamping/update/" + item.kid + "/" + item.kitem}>
                            <button className="btn-agis-light-outline" style={{height: "40px", width: "40px", minWidth: "40px", borderRadius: "5px", marginRight: "12px"}}><FontAwesomeIcon icon={faPencilAlt} style={{fontSize: "18px"}}/></button>
                            </Link>
                            <button className="btn-agis-light-outline" style={{height: "40px", width: "40px", minWidth: "40px", borderRadius: "5px"}} onClick={() => this.delete(item.kid, item.kitem)}><FontAwesomeIcon icon={faTrash} style={{fontSize: "18px"}}/></button>
                        </div>
                    </div>
                </div>
            );
        }).reverse();
    }
    }

    render() {
        const {lang} = this.context;

        const meta = {
			title: localization[lang].title,
			description: localization[lang].title,
			meta: {
			  	charset: 'utf-8'
			}
        };

        if (this.state.isLoading) {
            return (
                <div>Loading...</div>
            );
        }

        return (
            <div>
                <DocumentMeta {...meta} />
                <OffsetTop submenu={false} />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">
                            <div className="container-fluid pl-0 pr-0">
                                <div className="row mb-3">
                                    <div className="col d-flex justify-content-between">
                                        <button className="btn-agis-light-outline" style={{height: "36px", width: "36px", minWidth: "36px"}} onClick={this.datePrev}><FontAwesomeIcon icon={faChevronLeft}/></button>
                                        <input type="date" className="form-control form-control-sm ml-2 mr-2" style={{height: "36px", borderRadius: "10px"}} onChange={this.changeDate} value={this.dateToInputFormat(this.state.filterDate)}/>
                                        <button className="btn-agis-light-outline" style={{height: "36px", width: "36px", minWidth: "36px"}} onClick={this.dateNext}><FontAwesomeIcon icon={faChevronRight}/></button>
                                    </div>
                                </div>
                                <div className="text-center" style={{zIndex: "4", paddingRight: "10px", paddingLeft: "10px", paddingBottom: "10px", height: "60px"}}>
                                    <button type="button" className="btn btn-secondary btn-block" style={{backgroundColor: "#1a73e8", color: "white"}} onClick={() => this.autocompleteItem(this.state.rows[0].kid)}>Автозаповнення</button>
                                </div>
                                {this.renderList()}
                                <div className="fixed-bottom text-right" style={{zIndex: "4", paddingRight: "10px", paddingBottom: "10px", height: "60px"}}>
                                    <Link to={"/mechanic/stamping/new"} className="a-agis-light-outline" style={{height: '50px', width: "50px", minWidth: "0px", borderRadius: "25px", lineHeight: "44px", backgroundColor: "#1a73e8", color: "white", border: "1px solid #ebebeb", boxShadow: "0 1px 1px rgba(0,0,0,.15)"}}><FontAwesomeIcon icon={faPlus} style={{fontSize: "20px"}} /></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MechanicStamping;